import { Component } from '@angular/core';
import { AbstractInputDirective } from '../AbstractInputDirective';
import { ValidatorUtil } from '../../ValidatorUtil';

@Component({
  selector: 'digires-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
})
export class DateInputComponent extends AbstractInputDirective {
  public readonly ValidatorUtil = ValidatorUtil;
}
